export const sensorType = ['',
"dB",
"dBm",
"dBmV",
"dBμV",
"V",
"mV",
"μV",
"%",
"A",
"mA",
"μA",
"Ω",
"mΩ",
"μΩ",
"m/s²",
"mm",
"℃",
"℉",
"Pa",
"C",
"mC",
"μC",
"nC",
"pC",
"𝑢g/m³",
"MPa",
"μL/L",
"PPM",
"次"
]
export const sensorTypeOptions = [
    { type: 'UHF', label: '特高频局放' },
    { type: 'HFCT', label: '高频电流局放' },
    { type: 'PC', label: '脉冲电流局放'},
    { type: 'TEV', label: '暂态地电压局放' },
    { type: 'AE', label: '超声波局放' },
    { type: 'MECH', label: '三相共体机械特性' },
    { type: 'MECHSEP', label: '三相分体机械特性' },
    { type: 'DEVTEMP', label: '设备温度' },
    { type: 'ENVTEMP', label: '环境温度' },
    { type: 'ENVTH', label: '环境湿度' },
    { type: 'TEMP', label: '电缆温度' },
    { type: 'VIBRATION', label: '振动' },
    { type: 'OZONE', label: '臭氧' },
    { type: 'CT', label: '电流' },
    { type: 'GASTEMP', label: '气体温度' },
    { type: 'GASPRESS', label: '气体压力' },
    { type: 'GASDENSITY', label: '气体密度' },
    { type: 'GASMOIST', label: '气体水分' },
    { type: 'SF6', label: '六氟化硫'},
    { type: 'O2', label: '氧气'},
    { type: 'DCC', label: '避雷器放电计数'},
    { type: 'DCL', label: '避雷器泄露全电流'},
    { type: 'H2O', label: '油中微水含量'},
    { type: 'H2', label: 'H2油中浓度'},
    { type: 'CO', label: 'CO油中浓度'},
    { type: 'CH4', label: 'CH4油中浓度'},
    { type: 'C2H4', label: 'C2H4油中浓度'},
    { type: 'C2H6', label:'C2H6油中浓度'},
    { type: 'C2H2', label: 'C2H2油中浓度'},
    { type: 'CO2', label: 'CO2油中浓度'},
    { type: 'NMHC', label: '油中总烃'},
]
export const sensorTypeDic = {
  "UHF":"特高频局放",
  "HFCT":"高频电流局放",
  "PC":"脉冲电流局放",
  "TEV":"暂态地电压局放",
  "AE":"超声波局放",
  "MECH":"三相共体机械特性",
  "VIBRATION":"振动",
  "OZONE":"臭氧",
  "DEVTEMP":"设备温度",
  "ENVTEMP":"环境温度",
  "ENVTH":"环境湿度",
  "CT":"电流",
  "TEMP":"电缆温度",
  "GASTEMP":"气体温度",
  "GASPRESS":"气体压力",
  "GASDENSITY":"气体密度",
  "GASMOIST":"气体水分",
  "MECHSEP":"三相分体机械特性",
  "SF6":"六氟化硫",
  "O2":"氧气",
  "DCC":"避雷器放电计数",
  "DCL":"避雷器泄露全电流",
  "H2O":"油中微水含量",
  "H2":"H2油中浓度",
  "CO":"CO油中浓度",
  "CH4":"CH4油中浓度",
  "C2H4":"C2H4油中浓度",
  "C2H6":"C2H6油中浓度",
  "C2H2":"C2H2油中浓度",
  "CO2":"CO2油中浓度",
  "NMHC":"油中总烃",
}

export const characteristicValue =  {//特征值
    'AE': {dw:'',name:'最大放电幅值：'},
    'UHF': {dw:'',name:'最大放电幅值：'},
    'TEV': {dw:'',name:'最大放电幅值：'},
    'MECH': { dw: '', name: '开合闸状态：' },
    'HFCT': { dw: '', name: '最大放电幅值：' },
    'OZONE': {dw:'',name:'臭氧：'},
    'VIBRATION': {dw:'',name:'振动：'},
    'DEVTEMP': {dw:'',name:'设备温度：'},
    'ENVTEMP': {dw:'',name:'环境温度：'},
    'ENVTH': { dw: '', name: '环境湿度：' },
    'CT': { dw: '', name: '电流：' },
    "TEMP":{ dw: '', name: '电缆温度：'},
    'GASTEMP': { dw: '', name: '气体温度：' },
    'GASPRESS': { dw: '', name: '气体压力：' },
    'GASDENSITY': { dw: '', name: '气体密度：' },
    'GASMOIST': { dw: '', name: '气体水分：' },
    'MECHSEP': { dw: '', name: '开合闸状态：' },
    'SF6': { dw: '', name: 'SF6气体浓度：' },
    'O2': { dw: '', name: 'O2气体浓度：' },
    'PC': { dw: '', name: '最大放电幅值：' },
    "DCC": { dw: '', name: "避雷器放电计数：" },
    "DCL": { dw: '', name: "避雷器泄露全电流：" },
    "H2O": { dw: '', name: "油中微水含量：" },
    "H2": { dw: '', name: "H2油中浓度：" },
    "CO": { dw: '', name: "CO油中浓度：" },
    "CH4": { dw: '', name: "CH4油中浓度：" },
    "C2H4": { dw: '', name: "C2H4油中浓度：" },
    "C2H6": { dw: '', name: "C2H6油中浓度：" },
    "C2H2": { dw: '', name: "C2H2油中浓度：" },
    "CO2": { dw: '', name: "CO2油中浓度：" },
    "NMHC": { dw: '', name: "油中总烃：" },
}

export const alarmLevel = ['正常', '诊断预警', '诊断报警', '长期趋势预警', '长期趋势报警','短期趋势预警','短期趋势报警']  //报警等级
export const sensorAlarmLevel = ['正常', '预警', '报警']  //报警等级
export const PDType = ['正常','尖端放电','悬浮放电','沿面放电','内部气隙放电','颗粒放电','干扰','其他']    //放电类型
export const mechState = ['-', '分闸', '合闸']

export const oneValueTypeList = ['DEVTEMP','OZONE','ENVTEMP','ENVTH','TEMP','CT', 
                                'GASTEMP','GASPRESS','GASDENSITY','GASMOIST','SF6','O2',
                                'DCC','DCL','H2O','H2','CO','CH4','C2H4','C2H6','C2H2','CO2','NMHC']
export const pdValueTypeList = ['HFCT', 'UHF', 'AE', 'TEV', 'PC']
export const alarmDescribeDict = {
  0: '正常',
  1: '尖端放电',
  2: '悬浮放电',
  3: '沿面放电',
  4: '内部气隙放电',
  5: '颗粒放电',
  6: '干扰',
  7: '其他',
  8: '长期趋势预警',
  9: '长期趋势报警',
  10: '短期趋势预警',
  11: '短期趋势报警',
  100: '阈值报警',
  101: '趋势报警'
}


export const sensorAlarmDescribeDict = {
    0: '正常',
    2: '电池电量低',
    3: '掉线',
    // 100: '阈值报警',
    // 101: '趋势报警',
    255: '其他'
}

export const processedNumDict = {
  0: '未处理',
  1: '手动处理',
  2: '自动处理'
}

export const terndColor = {
  'peak': '#d60000ff',
  'average': '#ce00d9ff',
  'F50': '#0053d9ff',
  'F100': '#00b8d9ff',
  "DenoisingN": '#00d97fff',
  'amplitude': '#c0d900ff',
  'battery': '#d9b500ff',
  'rssi': '#d93a00ff',
  'snr': '#d7bd8dff'
}

export const UHFbandWidth = {
  1: '全通',
  2: '低通',
  3: '高通'
}

export const PCbandWidth = {
  1: '全通',
  2: '高通',
  3: '带通1',
  4: '带通2',
  5: '低通'
}

export const HFCTbandWidth = {
  1: '全通',
  2: '高通',
  3: '带通1',
  4: '带通2',
  5: '低通'
}


// WEBPACK FOOTER //
// ./src/util/sensorType.js